<template>
  <div>
    <nav-top></nav-top>
   <nav-left v-show="!isCreatePage"
             @showAllLeft="changeStatus"
             :style="{zIndex: isShowAllLeft ? 2001 : 2100}"></nav-left>
  </div>
</template>

<script>
import { hashAfterEach } from '../../utils/tools';
import NavTop from './NavTop.vue';
import NavLeft from './NavLeft.vue';
import actionTypes from '../../store/action-types';
import mutationTypes from '../../store/mutation-types';

export default {
  components: {
    NavTop,
    NavLeft
  },

  data() {
    return {
      isShowSettingPanel: false,
      isShowAllLeft: false,
    }
  },

  computed: {
    isCreatePage() {
      return this.$store.state.isCreatePage;
    }
  },

  created() {
    this.init();
  },

  methods: {
    init() {
      this.$store.dispatch(actionTypes.GET_NAV_TOP_MENU);
      this.$store.dispatch(actionTypes.GET_NAV_LEFT_MENU);
      this.$store.dispatch(actionTypes.GET_REGION);
      this.$store.dispatch(actionTypes.GET_USER_INFO);
      this.$store.dispatch(actionTypes.GET_ACCOUNT_REMAINDER);
      this.$store.dispatch(actionTypes.GET_MESSAGE_COUNT);
      this.$store.dispatch(actionTypes.GET_UNREAD_MESSAGE);
      this.$store.dispatch(actionTypes.GET_PENDING_ORDER);
      hashAfterEach(this.$store);
    },
    changeStatus(status) {
      this.isShowAllLeft = status;
    }
  }
}
</script>

<style>

</style>
